import { Link } from 'react-router-dom';
import styled from '@emotion/styled/macro';
// import { IconSquare, IconSquareCheck } from '@tabler/icons';
import { BiSquare, BiCheckSquare } from 'react-icons/bi';
import { Box, Checkbox, Radio, Tag, Flex, Alert } from '@chakra-ui/react';

import theme from 'ui/theme/theme';
import Text from 'ui/Text';
import Button from 'ui/Button';
import CenteredWrapper from 'ui/CenteredWrapper';

export const Centered = styled(CenteredWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  min-height: calc(100vh - 170px); // essures footer is at the bottom
  @media screen and (min-width: ${theme.breakpoints.md}) {
    justify-content: flex-start;
    padding-top: 12px;
    // margin-left: 16px;
    margin-right: 16px;
    max-width: 1440px;
    min-height: calc(100vh - 90px); // footer floats on larger screens
    &.store-preview {
      max-width: 1440px;
    }
    &.listing-confirmation {
      max-width: 1440px;
    }
    &.centered-form {
      margin: 0 auto;
      max-width: 980px;
    }
    // &.right-form {
    //   margin: 0 auto;
    //   max-width: 1440px;
    // }
  }
  &.preview-header-footer {
    min-height: 0;
  }
`;

export const FlexItem = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const FlexRowRight = styled.div`
  display: flex;
  float: right;
`;

export const RightItem = styled.div`
  display: flex;
  float: right;
  margin-left: auto;
  right: 0;
`;

export const FormBox = styled.form`
  background-color: ${theme.colors.gray['0']};
  margin: 16px;
  color: ${theme.colors.semantics.default};
  @media screen and (min-width: ${theme.breakpoints.md}) {
    margin: 16px 0 32px 0;
    max-width: 1024px;
  }
`;

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
`;

export const WrappingGrid = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(325px, 1fr));
  &.small {
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  }
  // fits 4 textfields onto a line &.xs { grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); }
  // Makes the phone number field wrapper before the others &.strict { @media screen and (min-width: ${theme
    .breakpoints
    .md}) and (max-width: 964px) { grid-template-columns: repeat(auto-fit, minmax(440px, 1fr)); } }
`;

export const TwoColGrid = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-columns: repeat(2, minmax(95px, 1fr));
  &.fill-width {
    margin-right: 20px;
    @media screen and (max-width: 440px) {
      margin-right: 0px;
      width: 100%;
    }
  }
`;

export const ModalGrid = styled.div`
  display: grid;
  grid-gap: 0 20px;
  @media screen and (min-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: center;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 48px;
  margin-bottom: 8px;
`;
export const CheckBoxButton = styled.button`
  &:focus {
    box-shadow: 0 0 0 3px white;
  }
`;

export const UncheckedIcon = styled(BiSquare)`
  color: ${(props) =>
    props.error
      ? theme.colors.semantics.error
      : theme.colors.semantics.default};
`;

export const CheckedIcon = styled(BiCheckSquare)``;
export const CheckBoxText = styled(Text)`
  padding-left: 8px;
  width: 85%;
  @media screen and (min-width: ${theme.breakpoints.md}) {
    line-height: 24px;
  }
`;

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  background: ${theme.colors.gray['50']};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
`;

export const MonthlyPaymentText = styled(Text)`
  display: inline;
  line-height: 20px;
  margin-left: 8px;
  color: ${theme.colors.gray['700']};
`;

export const UL = styled.ul`
  margin-left: 16px;
  li {
    color: ${theme.colors.gray['700']};
  }
`;

export const HR = styled.hr`
  border-top: 1px solid ${theme.colors.gray['500']};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : '24px'};
  &.light {
    border-top: 1px solid ${theme.colors.gray['300']};
  }
  @media screen and (min-width: ${theme.breakpoints.md}) {
    margin-bottom: ${(props) =>
      props.marginBottom ? props.marginBottom : '48px'};
    &.margin-top {
      margin-top: 48px;
    }
    &.margin-top-light {
      margin-top: 48px;
      border-top: 1px solid ${theme.colors.gray['300']};
    }
  }
`;

export const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 240px;
  height: 200px;
  margin-top: 16px;
  margin-bottom: 24px;
  border: 2px dashed ${theme.colors.gray['300']};
  border-radius: 4px;
  padding: 28px 0;
  background-color: ${theme.colors.gray['100']};
  cursor: pointer;
  text-align: center;
  &.banner {
    width: 100%;
    height: 264px;
    padding: 56px 0;
  }
  &.documents {
    max-width: 556px;
    width: 100%;
    height: auto;
    padding: 24px;
    border: 2px dashed ${theme.colors.semantics.info};
    background-color: white;
    border-radius: 16px;
    cursor: 'default';
  }
`;

export const ImgPreview = styled.img`
  max-width: 120px;
  max-height: 120px;
  border-radius: 8px;
`;

export const BannerImgPreview = styled.img`
  max-width: 100%;
  border-radius: 8px;
`;

export const IconButton = styled(Button)`
  display: flex;
  align-content: center;
  margin-bottom: 12px;
  border: none;
  font-weight: normal;
  &.bottom-spacing {
    margin-bottom: 24px;
  }
  &.no-margin {
    margin-top: 4px;
    margin-bottom: 0px;
  }
`;

export const ModalLink = styled.span`
  color: ${theme.colors.semantics.link};
  text-decoration: underline;
  cursor: pointer;
`;

export const CSVLink = styled(Text)`
  color: ${theme.colors.semantics.link};
  font-weight: bold;
  cursor: pointer;
  right: 0;
  margin: 60px 0 14px auto;
  &:hover {
    text-decoration: underline;
  }
`;

export const DayPickerWrapper = styled.div`
  display: flex;
`;

export const DayOption = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  margin-right: 8px;
  border: 2px solid ${theme.colors.semantics.link};
  border-radius: 50%;
  color: ${theme.colors.semantics.link};
  cursor: pointer;
  &.selected {
    border: none;
    background-color: ${theme.colors.semantics.link};
    color: white;
  }
`;

export const CardContainer = styled(Box)`
  border: 1px solid ${theme.colors.gray['400']};
  border-radius: 16px;
  object-fit: contain;
  margin-bottom: 24px;
  display: grid;
  width: 256px;
  height: 200px;
`;

export const CardWrapper = styled.div`
  margin-bottom: 1rem;
  display: grid;
  column-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(256px, 1fr));
`;

export const MultiImageUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 210px;
  height: 200px;
  border: 2px dashed ${theme.colors.gray['300']};
  border-radius: 4px;
  padding: 24px 0;
  background-color: ${theme.colors.gray['100']};
  cursor: pointer;
  text-align: center;
`;

export const $Radio = styled(Radio)`
  color: black;
  &[data-checked] {
    color: black;
    ::before {
      width: 75%;
      height: 75%;
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  border-color: ${(props) =>
    props.isError
      ? theme.colors.semantics.error
      : theme.colors.semantics.default};
  border-radius: 2px;
  margin-bottom: 8px;
  &.card {
    border-color: ${theme.colors.semantics.info};
    .chakra-checkbox__control[data-checked] {
      border-color: ${theme.colors.semantics.success};
      background: white;
      color: ${theme.colors.semantics.success};
    }
  }
  &.card-single-select {
    border-color: ${theme.colors.semantics.info};
    .chakra-checkbox__control {
      border-radius: 50%;
    }
    .chakra-checkbox__control[data-checked] {
      border-color: ${theme.colors.semantics.success};
      background: white;
      color: ${theme.colors.semantics.success};
    }
  }
  .chakra-checkbox__control[data-checked] {
    background: ${theme.colors.semantics.default};
  }
`;

export const PhotoFrame = styled.img`
  height: 600px;
  width: 600px;
  object-fit: cover;
  border-radius: 16px;
`;

export const PhotoThumbnailFrame = styled.img`
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 16px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${theme.colors.gray['100']};
  padding: 24px;
  align-items: center;
`;

export const ShippingCard = styled(Box)`
  border: 1px solid ${theme.colors.gray['400']};
  border-radius: 8px;
  object-fit: contain;
  margin-right: 16px;
  margin-bottom: 1rem;
  padding: 1rem;
  position: relative;
  width: 296px;
  height: 132px;
  border: ${(props) => (props.isSelected ? '3px solid' : '1px solid')};
  border-color: ${(props) =>
    props.isSelected
      ? theme.colors.semantics.success
      : theme.colors.gray['300']};
  &:hover {
    cursor: pointer;
  }
`;

export const SingleTag = styled(Tag)`
  color: ${theme.colors.semantics.link};
  border-color: ${theme.colors.semantics.link};
  background-color: ${theme.colors.semantics['link-light']};
  border-width: 1px;
  border-radius: 16px;
  width: 100px;
  height: 24px;
`;

export const StyledTag = styled(Tag)`
  color: ${theme.colors.semantics.link};
  border-color: ${theme.colors.semantics.link};
  background-color: ${theme.colors.semantics['link-light']};
  border-width: 1px;
  border-radius: 16px;
  height: 24px;
`;

export const CategoryChip = styled(Tag)`
  background-color: ${theme.colors.gray['200']};
  border-radius: 16px;
  height: 24px;
  margin-top: 12px;
  margin-right: 16px;
`;

export const LearnMore = styled(Link)`
  font-weight: bold;
  color: ${theme.colors.semantics.link};
  &:hover {
    text-decoration: underline;
  }
`;

export const HazardousWrapper = styled(Box)`
  background-color: #f8f3ec;
  border: 1px solid #ad5d14;
  margin-bottom: 40px;
`;

export const OnBoardingFooter = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  background: ${theme.colors.gray['100']};
  padding: 20px;
  width: 100%;
  border-radius: 8px;
`;

export const TextFieldWrapper = styled(Box)`
  padding-left: 12px;
  padding-right: 12px;
`;

export const FulfillmentTitle = styled(Box)`
  .chakra-input__group > input {
    border: 0;
  }
`;

export const CustomRadio = styled(Radio)`
  color: black;
  background: white;
  border-color: black;
  &[data-checked] {
    color: black;
    background: white;
    border-color: black;
  }
`;

export const AlertBox = styled(Alert)`
  align-items: start;
  color: black;
  padding: 16px;
  border-width: 1px;
  border-radius: 4px;
  margin: 24px 0px;
`;
